export default "__VITE_ASSET__BGf2IMkx__"